import Default from './parts/Default';
import Loading from './parts/Loading';
import Success from './parts/Success';
import Error from './parts/Error';

const Fortune = {
  Default,
  Loading,
  Success,
  Error,
};

export default Fortune;
